import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSort = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.53728 6.15496C7.85728 6.46496 7.63728 7.00496 7.18728 7.00496H5.89728V17.005H7.18728C7.63728 17.005 7.85728 17.545 7.54728 17.855L5.25728 20.145C5.05728 20.345 4.74728 20.345 4.54728 20.145L2.25728 17.855C1.93728 17.545 2.15728 17.005 2.60728 17.005H3.89728V7.00496H2.60728C2.15728 7.00496 1.93728 6.46496 2.24728 6.15496L4.53728 3.85496C4.73728 3.65496 5.04728 3.65496 5.24728 3.85496L7.53728 6.15496ZM20.8973 7.00496H10.8973C10.3473 7.00496 9.89728 6.55496 9.89728 6.00496C9.89728 5.45496 10.3473 5.00496 10.8973 5.00496H20.8973C21.4473 5.00496 21.8973 5.45496 21.8973 6.00496C21.8973 6.55496 21.4473 7.00496 20.8973 7.00496ZM20.8973 17.005H10.8973C10.3473 17.005 9.89728 17.455 9.89728 18.005C9.89728 18.555 10.3473 19.005 10.8973 19.005H20.8973C21.4473 19.005 21.8973 18.555 21.8973 18.005C21.8973 17.455 21.4473 17.005 20.8973 17.005ZM10.8973 11.005H20.8973C21.4473 11.005 21.8973 11.455 21.8973 12.005C21.8973 12.555 21.4473 13.005 20.8973 13.005H10.8973C10.3473 13.005 9.89728 12.555 9.89728 12.005C9.89728 11.455 10.3473 11.005 10.8973 11.005Z",
		fill: "currentColor"
	})
});
export default SvgSort;
